import { useField } from 'react-final-form';
import { NotesInputField } from './NotesInputField';

type SaveCB = (message: string, field?: string) => Promise<void> | void;

export const AiPreview = ({ fieldId, save }: { fieldId: string; save: SaveCB }) => {
  const { input: notesInput } = useField(fieldId, { subscription: { value: true } });

  const setNotes = (notes: string) => {
    notesInput.onChange(notes);
    save(notes, 'ai_message');
  };

  return <NotesInputField autoFocus={false} initialValue={notesInput.value} save={setNotes} />;
};
